import React, { useState } from "react";
import { Form, Input, Button, Card, Typography, message } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { resetPassword } from "../../api/Auth";
const { Title } = Typography;

const sessiData = JSON.parse(sessionStorage.getItem("user"));
const ChangePasswordPage = () => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const onFinish = async (values) => {
    setIsLoading(true);
    const payload = {
      old_pass: values.currentPassword,
      new_pass: values.newPassword,
      conf_pass: values.confirmPassword,
      userId: sessiData[0].user[0].userid,
    };

    try {
      const res = await resetPassword(payload);
      if (res.data.status) {
        message.success(res.data.message);
        form.resetFields();
      } else {
        message.error(res.data.message);
      }

      setIsLoading(false);
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        "Terjadi kesalahan saat mengubah password";
      message.error(errorMsg);
      setIsLoading(false);
    }
  };

  const validateNewPassword = (_, value) => {
    if (value && value.length < 6) {
      return Promise.reject(new Error("Password harus minimal 6 karakter"));
    }
    return Promise.resolve();
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f0f2f5",
      }}
    >
      <Card style={{ width: 400, padding: 24 }} bordered={false}>
        <Title level={3} style={{ textAlign: "center" }}>
          Ganti Password
        </Title>

        <Form
          form={form}
          name="change_password"
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            name="currentPassword"
            label="Password Lama"
            rules={[{ required: true, message: "Masukkan password lama Anda" }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Password lama"
            />
          </Form.Item>

          <Form.Item
            name="newPassword"
            label="Password Baru"
            rules={[
              { required: true, message: "Masukkan password baru" },
              { validator: validateNewPassword },
            ]}
            hasFeedback
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Password baru"
            />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            label="Konfirmasi Password Baru"
            dependencies={["newPassword"]}
            hasFeedback
            rules={[
              { required: true, message: "Konfirmasi password baru Anda" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Konfirmasi tidak cocok dengan password baru")
                  );
                },
              }),
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Konfirmasi password"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={isLoading}>
              Ubah Password
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default ChangePasswordPage;
